import { cn } from "@/lib/utils";

export default function BillingToggle({ value, onChange }) {
  const isAnnual = value === "annually";

  return (
    <div className="inline-flex items-center gap-3">
      <button
        type="button"
        onClick={() => onChange("monthly")}
        className={cn(
          "text-sm font-medium transition-colors",
          !isAnnual ? "text-neutral-900" : "text-neutral-400"
        )}
      >
        Monthly
      </button>

      <button
        type="button"
        role="switch"
        aria-checked={isAnnual}
        aria-label="Toggle billing period"
        onClick={() => onChange(isAnnual ? "monthly" : "annually")}
        className={cn(
          "relative h-7 w-14 shrink-0 rounded-full",
          "bg-gradient-to-b from-white to-neutral-200",
          "shadow-[inset_0_1px_2px_rgba(0,0,0,0.06)] ring-1 ring-black/10"
        )}
      >
        <span
          className="absolute top-1/2 h-5 w-5 -translate-y-1/2 rounded-full bg-[#0A1429] shadow-md transition-[left] duration-200 ease-out"
          style={{ left: isAnnual ? "calc(100% - 1.25rem - 0.25rem)" : "0.25rem" }}
        />
      </button>

      <button
        type="button"
        onClick={() => onChange("annually")}
        className={cn(
          "text-sm font-medium transition-colors",
          isAnnual ? "text-neutral-900" : "text-neutral-400"
        )}
      >
        Annually
      </button>
    </div>
  );
}
